import React from 'react';

export default function FormPage1({
  numberOfDripTrays,
  setNumberOfDripTrays,
  numberOfDripTraysEmptied,
  setNumberOfDripTraysEmptied,
  sizeOfDripTrays,
  setSizeOfDripTrays,
  gotoFormPage2,
}) {
  return (
    <div className="draught-wastage__page draught-wastage__form">
      <div className="draught-wastage__text-holder">
        <p className="draught-wastage__light draught-wastage__small-text">
          Answer the questions below to find out
        </p>
        <form onSubmit={gotoFormPage2}>

          <div>
            <label className="draught-wastage__icon-trays">
              How many drip trays do you use behind your bar?
            </label>
            <input
              placeholder="Enter the number of drip trays"
              type="number"
              value={numberOfDripTrays}
              onChange={(e) => setNumberOfDripTrays(e.target.value)}
              required
            />
          </div>
          <div className="draught-wastage__traysize">
            <label className="draught-wastage__icon-traysize">
              What size are your drip trays?
            </label>
            <div>
              <input
                id="size4"
                name="traysize"
                type="radio"
                value="0.75"
                checked={sizeOfDripTrays === '0.75'}
                onChange={(e) => setSizeOfDripTrays(e.target.value)}
                required
              />
              <label htmlFor="size4">4 inch</label>
              <input
                id="size6"
                name="traysize"
                type="radio"
                value="1.25"
                checked={sizeOfDripTrays === '1.25'}
                onChange={(e) => setSizeOfDripTrays(e.target.value)}
              />
              <label htmlFor="size6">6 inch</label>
            </div>
          </div>
          <div>
            <label className="draught-wastage__icon-emptied">
              How many drip trays are emptied in a day?
            </label>
            <input
              placeholder="Enter the number of drip trays emptied"
              type="number"
              value={numberOfDripTraysEmptied}
              onChange={(e) => setNumberOfDripTraysEmptied(e.target.value)}
              required
            />
          </div>

          <button type="submit">Enter your costs &gt;</button>
        </form>
      </div>
    </div>
  );
}
